import { getPermission, IMenuItem } from 'O3_core';
import {
  SUPPORT_NOTIFICATION_SETTING_RESOURCE,
  SUPPORT_NOTIFICATION_SETTING_SCOPES,
  SUPPORT_TICKET_RESOURCE,
  SUPPORT_TICKET_SCOPES,
} from './support-resources';

/**
 * Gated by the dedicated menu-visibility scope since the UI scopes rollout
 * (`docs/features/ui-menu-visibility-scopes.md` in the API repo). A user
 * without `support.ticket:SideMenuItem` will not see their own tickets — so
 * that scope belongs on every role, since filing a ticket is something anyone
 * in the HIS does.
 *
 * It sits outside the `Support` group below, in the daily-operations
 * category: reporting a problem is everybody's business, while that group is
 * the support team's own workspace.
 */
export const SupportMyTicketsSMIs: IMenuItem[] = [
  {
    id: '21000',
    label: 'sideMenuItems.support.myTickets',
    icon: 'ti ti-lifebuoy',
    routerLink: '/support/my-tickets',
    permission: getPermission(
      SUPPORT_TICKET_RESOURCE,
      SUPPORT_TICKET_SCOPES.SideMenuItem,
    ),
  },
];

/** The queue. Gated: no support role, no entry. */
const SupportConsoleSMIs: IMenuItem[] = [
  {
    id: '21001',
    label: 'sideMenuItems.support.console',
    icon: 'ti ti-headset',
    routerLink: '/support/console',
    permission: getPermission(
      SUPPORT_TICKET_RESOURCE,
      SUPPORT_TICKET_SCOPES.SideMenuItem,
    ),
  },
];

/**
 * Notification configuration. Gated on its own resource rather than on the
 * ticket one: reading the support queue and deciding who gets emailed about it
 * are different privileges.
 *
 * The route still guards on `Get`, which is the scope that actually protects
 * the data. This one only decides whether the entry is drawn.
 */
const SupportConfigurationSMIs: IMenuItem[] = [
  {
    id: '21002',
    label: 'sideMenuItems.support.configuration',
    icon: 'ti ti-settings',
    routerLink: '/support/notifications/settings',
    permission: getPermission(
      SUPPORT_NOTIFICATION_SETTING_RESOURCE,
      SUPPORT_NOTIFICATION_SETTING_SCOPES.SideMenuItem,
    ),
  },
];

/**
 * The support team's group.
 *
 * The parent carries no `routerLink` and no `permission` of its own: the
 * sidebar hides a parent whose children are all filtered out, so permission
 * lives on the leaves and the group appears exactly when something inside it
 * is reachable.
 */
export const SupportSMIs: IMenuItem[] = [
  {
    id: '21100',
    label: 'sideMenuItems.support._label',
    icon: 'ti ti-lifebuoy',
    items: [...SupportConsoleSMIs, ...SupportConfigurationSMIs],
  },
];
